<template>
  <div>
    <div :class="$style.body">
      <div :class="$style.ggaFirstText">
        Immer genau genug: Internetgeschwindigkeit bis zu 1 Gbit/s
      </div>
      <div>
        Die GGA Maur bietet Internet, Mobile, Fernsehen und Telefonie aus der Region – ohne
        Mindestvertragsdauer.
      </div>
    </div>
    <div :class="$style.buttonContainer">
      <PartnerTrackedLink
        ref="learnMoreButton"
        target="_blank"
        theme="secondary-bordered"
        rel="noopener"
        :href="ggaMaurUrl"
        @click="trackClick"
      >
        Mehr erfahren
      </PartnerTrackedLink>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import PartnerTrackedLink from '@/components/PartnerIntegrations/PartnerTrackedLink/PartnerTrackedLink.vue';
import {
  InteractionContainerDetail,
  InteractionContainerName,
  InteractionGoal,
} from '@/helpers/GTM/GTMParameters';

import { trackPartnerTooltip } from '../functions/tracking';

defineOptions({
  name: 'GgaMaurWidgetContent',
});

const ggaMaurUrl = computed((): string => {
  return 'https://www.gga.ch/internet-neuen-zuhause?utm_source=homegate&utm_medium=link&utm_campaign=internet-neuen-zuhause';
});

const trackClick = (): void => {
  trackPartnerTooltip(
    InteractionGoal.REPORT_ADDRESS_CHANGE,
    InteractionContainerName.GGA_MAUR,
    InteractionContainerDetail.INTERNET_PROVIDER,
  );
};
</script>

<style lang="scss" module>
@import '@/assets/variables';

.learnMoreButton {
  @include font-bold;
}

.body {
  margin-bottom: $space-150;
}

.ggaFirstText {
  padding-bottom: $space-75;
}
</style>
